<template>
    <div class="table-outer-box">
        <p>
            单位名称:{{ list.uName }}
            <el-image class="img" :src="require('../assets/img/edit.png')" @click="linkToEdit(list)"></el-image>
        </p>

        <ul>
            <li v-for="item in titleList">
                <span style="color: black;">
                    {{ item.label }}:
                </span>
                <span>
                    {{ list[item.val] }}
                </span>

            </li>
        </ul>
    </div>

</template>
<script type="text/ecmascript-6">
import { Toast, MessageBox } from 'mint-ui';
import { resetPassword, userLock } from "../api/userMG";
export default {
    props: {
        list: Object,
        titleList: Array
    },
    data() {
        return {

        }
    },
    created() {
    },
    methods: {
        linkToEdit(val) {
            this.$router.push({
                name: "addUnit",
                params: {
                    type: '编辑',
                    val: val
                }
            });
        },
    }
}

</script>
<style scoped lang="less">
.table-outer-box {
    display: flex;
    flex-direction: column;
    flex: 1;

    p {
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        text-indent: 10px;
        padding: 5px 0;
        border-bottom: 1px solid #D3D3D3;
        background: #6495ED;
        color: white;

        .img {
            width: 20px;
            height: 20px;
            float: right;
            margin-right: 15px;
            overflow: visible;
        }
    }


    ul {
        width: 100%;
        overflow: hidden;
        padding: 0 5px;

        li {
            width: 48%;
            height: 17px;
            float: left;
            text-decoration: none;
            margin: 2px 0;

            span {
                display: inline-block;
                height: 17px;
                line-height: 17px;
            }

            span:last-child {
                color: #808080;
                display: inline-block;
                white-space: nowrap;
                /*强制单行显示*/
                text-overflow: ellipsis;
                /*文本超出部分省略号表示*/
                overflow: hidden;
                /*文本超出部分隐藏*/
                width: 62%;
                /*设置文本显示的最大宽度*/
                display: inline-block
                    /*设为行内块元素*/
                ;
                vertical-align: top
            }
        }

        li::marker {
            content: "";
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/unitTable.vue